import Vue from 'vue';

import App from './App';
import router from './router';
import './filters';
import './directive/index';
// 引入 axios
import './util/axios';
import utils from './util/utils';

import store from './store';
import ElementUI from 'element-ui';
import moment from 'moment';
import zhLocale from '@/common/lang/zh-CN';
import zh from '@/common/lang/zh';

import '../theme/index.css';
import Loading from './libs/loading/index';
import message from './libs/message/index';
// 国际化插件
import VueI18n from 'vue-i18n';

import '@/util/globalComponents';

import 'normalize.css';

//自动适配
import 'lib-flexible'

// 重置样式
import './css/common.less';
import './css/reset.less';
import './css/e2e-style.less';
import './css/el-reset.less';

Vue.config.productionTip = false;
Vue.prototype.$moment = moment;
// 全局方法库
Vue.use(utils);

// 使用国际化插件
Vue.use(VueI18n); // 通过插件的形式挂载
const i18n = new VueI18n({
  silentFallbackWarn: true,
  locale: 'zh', // 语言标识
  // this.$i18n.locale // 通过切换locale的值来实现语言切换
  messages: {
    zh: {      
      ...zh,
      ...zhLocale
    }, // 中文语言包
  }
});

Vue.use(message);
Vue.use(Loading);

Vue.use(ElementUI, { i18n: (key, value) => i18n.t(key, value) });

// messageBox 插件
import messageBox from './libs/messageBox';
import commentBox from './libs/commentBox';
import approvalBox, { RewriteLocale } from './libs/approvalBox';
import permission from './libs/permission';
import afterMeeting from './libs/afterMeeting';
import globalFunc from './libs/function';
import download from './libs/download';
import PDFViewer from './libs/PDFViewer';
import previewExcel from './libs/previewExcel';
import previewImg from './libs/previewImg';
import mapBox from './libs/amap';
import dictSelect from './libs/dictSelect/index';
RewriteLocale(i18n);
Vue.use(messageBox);
Vue.use(approvalBox);
Vue.use(commentBox);
Vue.use(permission);
Vue.use(afterMeeting);
Vue.use(PDFViewer);
Vue.use(previewExcel);
Vue.use(previewImg);
Vue.use(globalFunc);
Vue.use(download);
Vue.use(mapBox);
Vue.use(dictSelect);

import languageChoose from './libs/language';
Vue.use(languageChoose);

// 轻提示默认偏移量
import DonMessage from '@/util/message.js';
Vue.prototype.$message = DonMessage;

// copye
import Copy from './libs/copy';
Vue.use(Copy);

//引入echars
import  * as  echarts from 'echarts'
Vue.prototype.$echarts = echarts;

/* eslint-disable no-new */
const VueInstance = new Vue({
  el: '#app',
  i18n,
  router,
  store,
  template: '<App/>',
  components: {
    App
  }
});

window.vm = VueInstance;

export default VueInstance;



// WEBPACK FOOTER //
// ./src/main.js